// SqureApp color code
// const colors = {
//   background: '#264d6b',
//   primary: '#264d6b',
//   brand_50: '#F2F7FA',
//   brand_100: '#DBE9F2',
//   brand_200: '#BAD4E4',
//   brand_300: '#90B6CF',
//   brand_400: '#5F93B6',
//   brand_500: '#3C7299',
//   brand_600: '#2F5B7A',
//   brand_700: '#264D6B',
//   brand_800: '#1D3A51',
//   brand_900: '#14293A',
//   brand_950: '#0C1A25',
//   secondary: '#666360',
//   light: '#f4f4f4',
//   error: '#e53935',
//   warning: '#fdd835',
// };

// // SenecuraApp color code
// const colors = {
//   background: '#039be5',
//   primary: '#039be5',
//   secondary: '#666360',
//   light: '#f4f4f4',
//   error: '#e53935',
//   warning: '#fdd835',
// };

// SenevitaApp color code
// const colors = {
//   background: '#128c8e',
//   primary: '#128c8e',
//   secondary: '#666360',
//   light: '#f4f4f4',
//   error: '#e53935',
//   warning: '#fdd835',
// };

// gasconnect color code
const colors = {
  background: '#039be5',
  primary: '#039be5',
  brand_50: '#e5f5fc',
  brand_100: '#ccebf9',
  brand_200: '#b3e1f7',
  brand_300: '#9ad7f4',
  brand_400: '#81cdf2',
  brand_500: '#4eb9ec',
  brand_600: '#35afea',
  brand_700: '#039be5',
  brand_800: '#039be5',
  brand_900: '#028bce',
  brand_950: '#027cb7',
  secondary: '#666360',
  light: '#f4f4f4',
  error: '#e53935',
  warning: '#fdd835',
};

// Note: For the GasConnect server, uncomment the following changes in:
// D:\Project\Herton\Source\squre_web_e2ee\src\pages\signin\styles.js
//
// background: url(${signInBackgroundImage}) no-repeat center;
// This applies the background image for the GasConnect server.

export default colors;
